import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { FiList } from "react-icons/fi";
import { activeRolloverIsMixed, userIs401kRollIn } from "store/selectors/user";

import Button from "components/Button";
import type { RootState } from "types/state";
import RolloverInstructionsModal from "./RolloverInstructionsModal";
import PaychexRolloverInstructionsModal from "./PaychexRolloverInstructionsModal";

import "./PriorYearContributionCard.scss";
import IconBanner from "../../../../components/IconBanner";

const mapStateToProps = (state: RootState) => {
  const userState = (state.user.userState as { state?: unknown }).state;
  const accounts = state.accounts.iraAccounts;
  // PRESERVED BUG (conversion-only): `find` is used but never imported in this
  // module, so this throws a ReferenceError at runtime. Keeping it verbatim.
  // @ts-expect-error find is undefined here (preserved pre-existing bug)
  const account = find(accounts, {
    isProcessingRollover: false,
    state: "AccountActive",
    isRollover: true,
  });
  const accountId = account ? account.id : null;

  return {
    userState,
    accounts,
    accountId,
    isRolloverIsMixed: activeRolloverIsMixed(state),
    isPaychex: userIs401kRollIn(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  title?: string;
  subheader?: string;
  onClick?: boolean;
  accountNumber?: string;
  accountType?: string;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

interface State {
  showRolloverInstructionsModal: boolean;
}

class IndividualRolloverCard extends React.Component<Props, State> {
  constructor() {
    // @ts-expect-error preserved: original calls super() with no args
    super();

    this.state = {
      showRolloverInstructionsModal: false,
    };
  }

  render() {
    let modal;

    if (this.props.isPaychex) {
      modal = (
        <PaychexRolloverInstructionsModal
          show={this.state.showRolloverInstructionsModal}
          onSuccess={() => {
            this.setState({ showRolloverInstructionsModal: false });
          }}
          onClose={() => {
            this.setState({ showRolloverInstructionsModal: false });
          }}
          accountNumber={this.props.accountNumber}
          accountType={this.props.accountType}
        />
      );
    } else {
      modal = (
        <RolloverInstructionsModal
          show={this.state.showRolloverInstructionsModal}
          onSuccess={() => {
            this.setState({ showRolloverInstructionsModal: false });
          }}
          onClose={() => {
            this.setState({ showRolloverInstructionsModal: false });
          }}
        />
      );
    }

    return (
      <>
        <div className="rollover-banner">
          {modal}
          <IconBanner
            icon={<FiList color="white" stroke="#60A4BF" size={16} />}
            color="primary"
            title={this.props.title}
            subheader={this.props.subheader}
            actionComponent={
              <Button
                size="sm"
                color="action"
                name="action"
                btnLabel="View Instructions"
                onClick={() => {
                  this.setState({ showRolloverInstructionsModal: true });
                }}
              />
            }
          />
        </div>
      </>
    );
  }
}

export default connector(
  withApollo<OwnProps & PropsFromRedux>(IndividualRolloverCard)
);
